import { useEffect, useState, useContext, useCallback } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Typography, Menu, Divider, MenuItem, Button, Tooltip} from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import ReplayIcon from '@mui/icons-material/Replay';
import UndoIcon from '@mui/icons-material/Undo';
import RedoIcon from '@mui/icons-material/Redo';
import PanoramaFishEyeOutlinedIcon from '@mui/icons-material/PanoramaFishEyeOutlined';
import RadioButtonCheckedOutlinedIcon from '@mui/icons-material/RadioButtonCheckedOutlined';
import CreateIcon from '@mui/icons-material/Create';
import HomeIcon from '@mui/icons-material/Home';
import PeopleIcon from '@mui/icons-material/People';
import HomeWorkIcon from '@mui/icons-material/HomeWork';
import WorkspacesIcon from '@mui/icons-material/Workspaces';
import Swal from 'sweetalert2';

import './header.scss';
import homebuttonimg from '../../../assets/image/home-simple2.png';
import workSpaceImg from '../../../assets/image/workspace.png'
import workSpaceMenuImg from '../../../assets/image/workspace-menu.png'
import Logo from '../../../assets/image/icons/logo-bluecat.png';

import { tips } from '../../../util'
import { ExportPage } from './export';
import { Compress } from "./compress"
import { Convert } from "./convert"
import { UserAvatar } from '../../home-header/header';
import { ChangeProjectWorkspace, GetRegistration, ShareProject, createWorkspace, getProjectHistory, getWorkspacesList, renameWorkSpace } from '../../../axios/ApiProvider';
import { EmailValidate } from '../../../provider/validate/FormValidate';
import { ProjectJSON_Store, sequenceStatus_Store, sequenceNum_Store } from '../../../store/actions/projectdata';
import {languageCode_Store} from '../../../store/actions/mainAction';
import { useGlobalContext } from '../../../provider';
import { languageStrs_Store } from '../../../store/actions/editAction';
import Badge from '@mui/material/Badge';
import { editorLangEnStrs } from '../../../lang/editor_string_en';
import { editorLangGmStrs } from '../../../lang/editor_string_gm';
import LanguageIcon from '@mui/icons-material/Language';
import PricingModal from '../../../pages/Pricing/pricingModal';
import { ColorModeContext, tokens, useMode } from '../../../theme/themeProvider';
import LightModeIcon from '@mui/icons-material/LightMode';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import LightDarkModeToggle from '../../light-dark-mode/lightDarkMode';
import collaborateIcon from '../../../assets/image/header/collaborate.svg'

let apiController = null;
const HOME_FRONTEND_URL = process.env.REACT_APP_BASE_FRONTEND_HOME_URL


let mobileScreenDetect = false
if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(navigator.userAgent||navigator.vendor||window.opera)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test((navigator.userAgent||navigator.vendor||window.opera).substr(0,4))){
  mobileScreenDetect = true;
}

export const HeaderSection = () => {
  const theme = useTheme();
	const colors = tokens(theme.palette.mode);
	const colorMode = useContext(ColorModeContext);

  const languageStrs = useSelector((store) => store.editdata.languageStrs)
  const dispatch = useDispatch();
  const sequenceNumber = useSelector((store) => store.projectdata.sequenceNumber);
  const projectUUID = useSelector((store) => store.projectdata.projectUUID);
  const ProjectJSON = useSelector(store => store.projectdata.projectJSON);
  const loginState = useSelector((store) => store.maindata.loginState);
  const [isUndoing, setIsUndoing] = useState(false);

  
  const [userCredentials, setUserCredentials] = useState(null);
  // const getUserCredentials = async () => await GetRegistration().then(res => setUserCredentials(res.data));
  // getUserCredentials();
  // console.log(userCredentials)


  const [projectName, setProjectName] = useState('');
  const [searchParams] = useSearchParams();
  const from = searchParams.get("from");
  // const theme = useTheme();
  const downSM = useMediaQuery(theme.breakpoints.down("sm"))

  const [showPricingPageModal, setShowPricingPageModal] = useState(false)

  const handleClosePricingModal = () => {
    setShowPricingPageModal(false)
  }

  const onBlue = () => {
    let tempJSON = JSON.parse(JSON.stringify(ProjectJSON));
    if (!tempJSON?.title && tempJSON?.title !== '') return;
    if (tempJSON?.title === projectName) return;
    dispatch(ProjectJSON_Store({ ...tempJSON, title: projectName }));
  }

  const onChange = (e) => {
    let value = e.target.value
    setProjectName(value)
  }

  useEffect(() => {
    let name = '';
    if (!!ProjectJSON?.title) name = ProjectJSON.title;
    setProjectName(name);
  }, [ProjectJSON]);

  const isKeyboardPlaying = (e) => {
    if(e.target.nodeName == "BODY"){
      if((e.key == 'z'||e.keyCode == 90) && e.metaKey == true && e.shiftKey == false){
        settingBackFunc(-1);
      }
      if((e.key == 'z'||e.keyCode == 90) && e.metaKey == true && e.shiftKey == true){
        settingBackFunc(1);
      }
    }
  }
  useEffect(() => {
    window.addEventListener('keydown', isKeyboardPlaying, false);
    return () => {
      window.removeEventListener("keydown", isKeyboardPlaying)
    }
  }, [sequenceNumber])
  
  const settingBackFunc = async (flag) => {
    if (sequenceNumber.c === undefined) return;

    let type = 'undo';
    let sequence = sequenceNumber.c + flag;
    
    if (sequence < 0 || sequenceNumber.m < sequence) return;
    if(apiController != null){
      apiController.abort();
    }
    dispatch(sequenceNum_Store({ ...sequenceNumber, c: sequence }));
    dispatch(sequenceStatus_Store(false));
    // apiController.signal;
    apiController = new AbortController();
    let response = await getProjectHistory(projectUUID, type, sequence, apiController)
    let history = response.data?.history;
    if (response.state !== "success" || !history) return;
    let sequenceNum = response.data.sequence;
    let newJSON = { ...history, sequence: sequenceNum, asset: ProjectJSON.asset };
    // dispatch(sequenceNum_Store({ ...sequenceNumber, c: sequenceNum }));
    dispatch(sequenceStatus_Store(false));
    apiController = null;
    dispatch(ProjectJSON_Store(newJSON));
   
  }

  const [userData, setUserData] = useState({})
  useEffect(() => {
    let tempData = {}
    let item = localStorage.getItem('user_data')
    if (!!item && JSON.parse(item)?.state === 'loggedin') tempData = JSON.parse(item)
    setUserData(tempData)
  }, [loginState])

  const toHome = e => {
    e.preventDefault();
    // This now only handles direct clicks, not right-clicks
    const url = loginState ? `${HOME_FRONTEND_URL}/dashboard/projects` : HOME_FRONTEND_URL;
    window.location.href = url;
  }
  const changeDarkLightMode = () => {
		//console.log('mode', colors);
		colorMode.toggleColorMode();
	}
  return (
    <Box className={`v-homeheader px-1 py-2 ${theme.palette.mode === 'dark' ? 'dark' : 'light'}`}>
      <Box className='v-homeheaderleft'>
        {/* {!mobileScreenDetect &&
          <Box className='d-logoImg mobile:border-none'>
            <Link to={'..'} onClick={toHome}>
              <img src={homebuttonimg} alt='homebuttonimg' style={{ maxHeight : '40px', objectFit: 'contain' }} />
            </Link>
          </Box>
        } */}

        <Box className="d-logoImg">
          {userData?.company_visual ? (
            <Box className='flex items-center'>
             <a href={loginState ? `${HOME_FRONTEND_URL}/dashboard/projects` : HOME_FRONTEND_URL}>
                   {/* <img src={homebuttonimg} alt='homebuttonimg' style={{ maxHeight: '60px', marginRight: '5px'}} /> */}
                <HomeIcon sx={{fontSize: {sm: '32px', xs: '24px'}, mx: {sm: 2, xs: 0}, fill: '#685dd8'}}/> 
              </a>
              <a href={loginState ? `${HOME_FRONTEND_URL}/dashboard/projects` : HOME_FRONTEND_URL}>
                <img src={userData?.company_visual} className='company-logo' alt='logoimgGG' />
              </a>
              <div className='w-full' style={{ flexGrow: 1, padding: '0 10px' }}>
                <input
                  onBlur={onBlue}
                  value={projectName}
                  onChange={onChange}
                  className='w-full text-12 mobile:text-15 project-name'
                  placeholder={projectName}
                />
              </div>
            </Box>
          ) : (
            <Box className='flex items-center'>
              <a href={loginState ? `${HOME_FRONTEND_URL}/dashboard/projects` : HOME_FRONTEND_URL} className='home-icon-link'>
                {/* <img src={homebuttonimg} alt='homebuttonimg' style={{ maxHeight: '60px', marginRight: '5px'}} /> */}
              <HomeIcon sx={{fontSize: {sm: '32px', xs: '24px'}, mx: {sm: 2, xs: 0}, fill: theme.palette.mode === 'dark' ? '#cccdd0':'#393939'}}/> 
              </a>
              <a href={loginState ? `${HOME_FRONTEND_URL}/dashboard/projects` : HOME_FRONTEND_URL}>
                <img className='logged-out-videoo-logo' src={Logo} alt='logoimgggh' style={{ maxHeight: '60px' }} />
                <HomeIcon sx={{display: {xs: 'block', sm: 'none'} ,fontSize: {sm: '32px', xs: '24px'}, ml: {sm: 2, xs: 1}, fill: '#685dd8'}}/> 
              </a>
              <div className='w-full' style={{ flexGrow: 1, padding: '0 10px' }}>
                <input
                  onBlur={onBlue}
                  value={projectName}
                  onChange={onChange}
                  className='w-full text-12 mobile:text-15 project-name'
                  placeholder={projectName}
                />
              </div>
            </Box>
          )}
          
        </Box>

      </Box>

      <Box className='v-homeheaderright v-right gap-2 md:gap-10'>
       
        {from === "feature-compress-video" && <Compress />}
        {from === "feature-convert-video" && <Convert />}
        <ExportPage projectName={projectName} />

        {!loginState ? (
          <Box className='v-center pl-2 mr-2 signin-signup'>
            <Typography component='h2' className='save-project'>{languageStrs.save_your_project_later}</Typography>
            <a href={`${HOME_FRONTEND_URL}/signin/?project_uuid=${projectUUID}`}>{languageStrs.sign_in}</a>
            {/* <Link component='a' to={`${HOME_FRONTEND_URL}/signin/?project_uuid=${projectUUID}`}>sign in</Link> */}

            <h2>or</h2><h5>·</h5>
            <a href={`${HOME_FRONTEND_URL}/signup/?project_uuid=${projectUUID}`}>{languageStrs.sign_up}</a>
            {/* <Link component='a' to={`/signup/?project_uuid=${projectUUID}`}>sign up</Link> */}
          </Box>
        ) : (
          <UserAvatar userData={userData} />
        )}
        <Box className='hidden sm:inline-flex '>
        
          <Tooltip title={'Undo'} arrow>
            <span>
              <Button disabled={sequenceNumber.c ? false : true} className='v-center gap-2 pointer undo_editBtn items-center' onClick={() => { settingBackFunc(-1) }}>
                {/* <Badge badgeContent={sequenceNumber.c?sequenceNumber.c:'0'} color="secondary"> */}
                <UndoIcon
                  className='undo-icon'
                />
                {/* </Badge> */}
                <Typography className={`hidden mobile:flex text-14 undo-redo ${theme.palette.mode === 'dark' ? 'dark' : 'light'}`}>
                  {/* {languageStrs.undo} | */} {sequenceNumber.c ? sequenceNumber.c : '0'}
                </Typography>
              </Button>
            </span>
          </Tooltip>

          <Tooltip title={'Redo'} arrow>
            <span>
              <Button disabled={sequenceNumber.m - sequenceNumber.c ? false : true} className='v-center items-center gap-2 pointer redo_editBtn' onClick={() => { settingBackFunc(1) }}>
                {/* <Badge badgeContent={(sequenceNumber.m-sequenceNumber.c)?(sequenceNumber.m-sequenceNumber.c):'0'} color="secondary"> */}
                <RedoIcon
                  // style={{ WebkitTransform: 'rotatey(180deg) rotate(-45deg)' }}
                  className='redo-icon'
                />
                {/* </Badge> */}
                <Typography className={`hidden mobile:flex text-14 undo-redo ${theme.palette.mode === 'dark' ? 'dark' : 'light'}`}>
                  {/* {languageStrs.redo} | */} {(sequenceNumber.m - sequenceNumber.c) ? (sequenceNumber.m - sequenceNumber.c) : '0'}
                </Typography>
              </Button>
            </span>
          </Tooltip>
        </Box>

        {downSM && !loginState 
          ? 
          <>
          </> 
          : <>

          <ProjectShare showPricingPageModal={showPricingPageModal} setShowPricingPageModal={setShowPricingPageModal} />
          <WorkspaceChange showPricingPageModal={showPricingPageModal} setShowPricingPageModal={setShowPricingPageModal} />

          </> }
          <Box className='mobile-theme-toggle'>
            {theme.palette.mode === "dark" &&
            <LightModeIcon 
            onClick={changeDarkLightMode} 
            sx={{fontSize: {sm: '32px', xs: '24px'}, fill: '#685dd8'}
            }/>}

            {theme.palette.mode === "light" &&
            <DarkModeIcon onClick={changeDarkLightMode} 
            sx={{fontSize: {sm: '32px', xs: '24px'}, fill: '#685dd8'}}
            />}
          </Box>

        <LightDarkModeToggle  mode={theme.palette.mode} toggleMode={changeDarkLightMode} />
        {/* <LangChangeSelector /> */}
      </Box>

      <PricingModal open={showPricingPageModal} onCloseModal={handleClosePricingModal} hasFeatureAccess={loginState}/>
      
    </Box>
  )
}

const LangChangeSelector = () => {
  const dispatch = useDispatch();
  const [isLanglist, setIsLanglist] = useState(null);
  const languageCode = useSelector((store) => store.maindata.languageCode);
  const handleLangSelected = (langStr) => {
    dispatch(languageCode_Store(langStr));
    setIsLanglist(null);
  }

  useEffect(() => {
    switch(languageCode){
      case 'EN':
        dispatch(languageStrs_Store(editorLangEnStrs));
        break;
      case 'GM':
        dispatch(languageStrs_Store(editorLangGmStrs));
        break;
      default:
        dispatch(languageStrs_Store(editorLangEnStrs));
        break;
    }
  }, [languageCode])

  return (
    <>
      <Button
        id="demo-positioned-button"
        onClick={(e) => { setIsLanglist(e.currentTarget) }}
      >
        <LanguageIcon />
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={isLanglist}
        open={Boolean(isLanglist)}
        onClose={() => { setIsLanglist(null) }}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        <MenuItem onClick={() => handleLangSelected('EN')}>English</MenuItem>
        <MenuItem onClick={() => handleLangSelected('GM')}>German</MenuItem>
      </Menu>
    </>
  )
}

const ProjectShare = (props) => {
  const {showPricingPageModal, setShowPricingPageModal} = props;
  const languageStrs = useSelector((store) => store.editdata.languageStrs);
  const ProjectJSON = useSelector(store => store.projectdata.projectJSON);
  const projectUUID = useSelector((store) => store.projectdata.projectUUID);
  const loginState = useSelector((store) => store.maindata.loginState);
  const [planMenuEl, setPlanMenuEl] = useState(null)
  const [shareMail, setShareMail] = useState('')

  const [userData, setUserData] = useState({})
  const [userPlan, setUserPlan] = useState(0);
  useEffect(() => {
    let tempData = {}
    let item = localStorage.getItem('user_data')
    if (!!item && JSON.parse(item)?.state === 'loggedin') tempData = JSON.parse(item)
    setUserData(tempData)
    setUserPlan(tempData.subscription)
  }, [loginState])

  const changeMail = (e) => {
    const value = e.target.value
    setShareMail(value)
  }

  
  const shareProject = async () => {
    try {
      if (!ProjectJSON?.workspace_uuid) {
        throw new Error('Please login')
      }

      if (!shareMail) {
        throw new Error('Please enter email address')
      }

      const checkMail = EmailValidate(shareMail)
      const tempMail = checkMail?.email

      if (!checkMail.status) {
        throw new Error('Please enter validate email address')
      }

      const workspace_uuid = ProjectJSON.workspace_uuid
      const result = await ShareProject(workspace_uuid, tempMail, projectUUID)

      if (result.state === 'success') {
        tips('success', 'Project share successed to ' + tempMail)
      }
    } catch (err) {
      tips('warning', err.message)
    }
  }

  const onOpenColllaborateList = (e) => {
    if(loginState){
      if ((userPlan == 3 || userPlan == 6)) {
        setPlanMenuEl(e.currentTarget);
      } else {
        setShowPricingPageModal(true);
      }
    } else{
      setShowPricingPageModal(true);
    }
    
  }
  const theme = useTheme();
  return (
    <>
      <div onClick={(e) => { onOpenColllaborateList(e) }}
        className='flex flex-row gap-3 items-center justify-center cursor-pointer select-none collabrate_hintCls'
      >
        <span className='hidden lg:inline text-13 collaborate'>{languageStrs.collaborate} </span>
        <WorkspacesIcon sx={{fontSize: {sm: '32px', xs: '24px'}}}/> 
        
      </div>

      <Menu
        anchorEl={planMenuEl}
        open={Boolean(planMenuEl)}
        onClose={() => { setPlanMenuEl(null) }}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right', }}
        transformOrigin={{ vertical: 'top', horizontal: 'right', }}
        PaperProps={{ sx: { mt: 1 } }}
        className="default-menu"
      >
        <div className="max-w-150 py-5 border-1 border-[#140505] rounded-lg outline-none"
          style={{ backgroundColor: theme.palette.background.default }}
        >
          <div className="flex flex-col gap-5">
            <div className="flex flex-col gap-5 cursor-pointer text-center">
              <div className="px-10 text-15 font-semibold leading-none">
                {languageStrs.enter_email_share_project}
              </div>

              <Divider className="w-full" />

              <div className="text-12 font-semibold leading-none">
                <input type='text'
                  value={shareMail}
                  placeholder='email@email.com'
                  className='default-input w-full px-10 text-15'
                  onKeyDown={(e) => { e.stopPropagation() }}
                  onChange={changeMail}
                />
              </div>
            </div>

            <Divider className="w-full" />

            <div className='flex flex-row items-center justify-center px-5 select-none'>
              <span onClick={shareProject}
                className='cursor-pointer hover:opacity-80'
              >
                {languageStrs.share_project}
              </span>
            </div>
          </div>
        </div>
      </Menu>
    </>
  )
}

const WorkspaceChange = (props) => {
  const {showPricingPageModal, setShowPricingPageModal} = props;
  const languageStrs = useSelector((store) => store.editdata.languageStrs);
  const [menuEl, setMenuEl] = useState(null)
  const [globalState, { onLoading }] = useGlobalContext()
  const ProjectJSON = useSelector(store => store.projectdata.projectJSON);
  const projectUUID = useSelector((store) => store.projectdata.projectUUID);

  const [firstLoad, setFirstLoad] = useState(false)
  const [workspaceType, setWorkspaceType] = useState(null)
  const [workSpacesList, setWorkSpacesList] = useState([])
  const [activeWorkspace, setActiveWorkspace] = useState(null)
  const loginState = useSelector((store) => store.maindata.loginState);

  useEffect(() => {
    getWorkSpaces()
  }, [])

  useEffect(() => {
    if (!firstLoad && ProjectJSON?.workspace_uuid) {
      let tempuuid = ProjectJSON?.workspace_uuid
      if (typeof tempuuid === 'string') {
        setWorkspaceType(tempuuid)
        setFirstLoad(true)
      }
    }
  }, [ProjectJSON])

  useEffect(() => {
    let checkworkspace = workSpacesList.find((workspace) => (
      workspace.uuid === workspaceType
    ))

    if (checkworkspace) {
      setActiveWorkspace(checkworkspace)
    } else if (activeWorkspace !== null) {
      setActiveWorkspace(null)
    }
  }, [workspaceType, workSpacesList])

  const getWorkSpaces = async () => {
    try {
      const result = await getWorkspacesList()

      if (result.state === 'success') {
        if (typeof result.data === 'object') {
          setWorkSpacesList(result.data)
        }
      }

      return true
    } catch (err) {
      console.log(err.message)
      return false
    }
  }

  const workspaceUUIDchange = async (uuid, flag) => {
    try {
      const checkUuid = workSpacesList.find((workspace) => (
        workspace.uuid === uuid
      ))

      if (checkUuid && uuid !== workspaceType) {
        onLoading(true)
        setMenuEl(false)

        let result = await ChangeProjectWorkspace(projectUUID, workspaceType, uuid)
        if (result.state === 'success') {
          onLoading(false)
          setWorkspaceType(uuid)

          if (!flag) {
            tips("success", 'workspace change successed')
          }
        } else {
          throw new Error('workspace change failure!')
        }
      }
    } catch (err) {
      onLoading(false)

      if (!flag) {
        tips("warning", err.message)
      }
    }
  }

  const createNewWorkspace = async () => {
    try {
      onLoading(true)
      setMenuEl(false)

      let result = await createWorkspace()
      if (result.state === 'success') {
        await getWorkSpaces()
        tips("success", result.data)
      } else {
        throw new Error('Create new workspace failure!')
      }

      onLoading(false)
    } catch (err) {
      tips("warning", err.message)
      onLoading(false)
    }
  }

  const onWorkSpaceList = (e) => {
    if(loginState){
      setMenuEl(e.currentTarget)
    }else{
      setShowPricingPageModal(true);
    }
  }

  const changeWorkSpaceName = (workspace) => {
    setMenuEl(null) 
    Swal.fire({
      title: "Change your workspace title",
      input: "text",
      showCancelButton: true,
      confirmButtonText: "Rename",
      showLoaderOnConfirm: true,
      inputValidator: (value) => {
        if (!value) {
          return "You need to write something!";
        }
      },
      preConfirm: async (renamestr) => {
        // try {
           const response = await renameWorkSpace(workspace.uuid, renamestr);
          // if (!response.ok) {
          //   return Swal.showValidationMessage(`
          //     ${JSON.stringify(await response.json())}
          //   `);
          // }
          // return response.json();
        // } catch (error) {
        //   Swal.showValidationMessage(`
        //     Request failed: ${error}
        //   `);
        // }
      },
      allowOutsideClick: () => !Swal.isLoading()
    }).then((result) => {
      if (result.isConfirmed) {
        getWorkSpaces();
        Swal.fire({
          title: `Workspace title changed`,
          imageUrl: result.value.avatar_url
        });
      }
    });
    // alert('Change WorkSpace');
  }
  const theme = useTheme();
  return (
    <div className=''>
      <div onClick={(e) => { onWorkSpaceList(e) }}
        className='flex flex-row items-center justify-center cursor-pointer select-none changeWorkspace_hintCls'
      >
        <span className='overflow-ellipsis max-w-150 hidden md:inline text-13'>
          {activeWorkspace?.title || ''}
        </span>
        {/* <img alt='' src={workSpaceMenuImg} className='w-30 h-30' /> */}
        <Tooltip title='Workspaces' arrow>
          <HomeWorkIcon sx={{fontSize: {sm: '32px', xs: '24px'}}}/> 
        </Tooltip>
       
        
      </div>

      <Menu anchorEl={menuEl}
        open={Boolean(menuEl)}
        onClose={() => { setMenuEl(null) }}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right', }}
        transformOrigin={{ vertical: 'top', horizontal: 'right', }}
        PaperProps={{ sx: { mt: 1 } }}
        className="default-menu"
      >
        <Box className='flex flex-col py-5' sx={{backgroundColor: theme.palette.background.default}}>
          <MenuItem onClick={createNewWorkspace} 
            className="toolbar-SortBy-select-item border border-solid border-black px-5"
          >
            <span>+ {languageStrs.create_new_workspace}</span>
          </MenuItem>

          {workSpacesList.map((workspace, key) => (
            <MenuItem key={key}
               className={`toolbar-SortBy-select-item ${workspace.uuid === workspaceType && 'Mui-selected'}`}
            >
              <div className='d-flex'
               onClick={() => { workspaceUUIDchange(workspace.uuid) }}
              >
                <PanoramaFishEyeOutlinedIcon className="radio-outline" />
                <RadioButtonCheckedOutlinedIcon className="radio-checked" />
                <span>{`${workspace?.title} (${workspace?.uuid})`}</span>
              </div>
              <CreateIcon onClick={() => {changeWorkSpaceName(workspace)}}/>
            </MenuItem>
          ))}
        </Box>
      </Menu>
    </div>
  )
}